import { render, staticRenderFns } from "./SingleQuestion.vue?vue&type=template&id=23da94bf&lang=pug&"
import script from "./SingleQuestion.vue?vue&type=script&lang=js&"
export * from "./SingleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports